import FormActions from "../actions/FormActions";
import NotificationActions from "../actions/NotificationActions";
import axiosInstance from "../../config/axios";
import Paths from "../../utils/paths";
import { generateXMLString } from "../../utils/functions/xml";

class FormMiddlewares {
  static publishXML() {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;
      const { activeCheckboxes, activeChildrens, ...rest } = state.form.form;

      try {
        dispatch(FormActions.publishXML());
        const xml = generateXMLString(rest, activeCheckboxes, activeChildrens);

        const response = await axiosInstance.post(
          Paths.PUBLISH,
          {
            podcast: xml,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        dispatch(FormActions.publishXMLSuccess(response.data.publish_url));
        dispatch(
          NotificationActions.addNotification(
            `Your xml is live`,
            "success",
            `${response.data.publish_url?.substring(0, 36)}...`,
            response.data.publish_url
          )
        );
      } catch (e) {
        dispatch(
          FormActions.publishXMLFailure(e?.response?.data?.message || e.message)
        );
        dispatch(
          NotificationActions.addNotification(
            e?.response?.data?.message || e.message,
            "error"
          )
        );
      }
    };
  }

  static savePodcast() {
    return async (dispatch, getState) => {
      try {
        dispatch(FormActions.savePodcast());
        const state = getState();
        const { activeCheckboxes, activeChildrens, categories, ...rest } =
          state.form.form;
        const fileName = state.form.fileName;
        const isLoggedIn = state.user.isLoggedin;

        const token = state.user.token;

        if (!isLoggedIn) return;

        const dataToSend = {
          podcast: {
            title: rest.title || "",
            image_url: rest.image_url || "",
            subtitle: rest.subtitle || "",
            summary: rest.summary || "",
            author: rest.author || "",
            owner: rest.owner || "",
            url: rest.url || "",
            lang: rest.lang || "",
            copyright: rest.copyright || "",
            cemail: rest.cemail || "",
            age_restriction:
              typeof rest.age_restriction === "undefined"
                ? ""
                : rest.age_restriction,
            keywords: rest.keywords || "",
            ...(rest.hasContentEncoded ? { hasContentEncoded: true } : {}),

            episodes: rest.episodes || [],
            checkboxes: activeCheckboxes,
            childrens: activeChildrens,
          },
          settings: {
            fileName,
          },
        };

        await axiosInstance.post(Paths.SAVE, dataToSend, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        dispatch(FormActions.savePodcastSuccess());
      } catch (e) {
        dispatch(
          FormActions.savePodcastFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static getMyPodcast() {
    return async (dispatch, getState) => {
      const state = getState();
      if (!state?.user?.isLoggedin) return null;

      try {
        dispatch(FormActions.getMyPodcast());

        // fetch podcast
        const response = await axiosInstance.get(Paths.GET_MY, {
          headers: {
            Authorization: `Bearer ${state?.user?.token}`,
          },
        });
        const podcast = response.data.podcast;

        dispatch(FormActions.getMyPodcastSuccess());

        return podcast;
      } catch (e) {
        dispatch(
          FormActions.getMyPodcastFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }
}
export default FormMiddlewares;
